import { create } from 'zustand';

type ForgotPasswordStep = 'request' | 'verify';

interface ForgotPasswordForm {
  email: string;
  code: string;
  newPassword: string;
}

interface ForgotPasswordStore {
  step: ForgotPasswordStep;
  isSubmitting: boolean;
  form: ForgotPasswordForm;
  setStep: (step: ForgotPasswordStep) => void;
  setIsSubmitting: (isSubmitting: boolean) => void;
  setForm: (form: Partial<ForgotPasswordForm>) => void;
  reset: () => void;
}

const initialForm: ForgotPasswordForm = {
  email: '',
  code: '',
  newPassword: '',
};

export const useForgotPasswordStore = create<ForgotPasswordStore>((set, get) => ({
  step: 'request',
  isSubmitting: false,
  form: initialForm,
  setStep: (step) => set({ step }),
  setIsSubmitting: (isSubmitting) => set({ isSubmitting }),
  setForm: (updates) => set({ form: { ...get().form, ...updates } }),
  reset: () => set({ step: 'request', isSubmitting: false, form: initialForm }),
}));
